import { Link } from "react-router-dom";

export default function RiskWarning() {
  return (
    <div className="risk-warning" role="note">
      <div className="wrap">
        <strong>Capital at risk.</strong> These are illiquid, long-term investments in private credit.
        You may lose all of the money you invest. The vehicles are not authorised by the Financial
        Conduct Authority and investments in them are not covered by the Financial Services Compensation
        Scheme or the Financial Ombudsman Service. Past performance is not a reliable indicator of future
        results. Available to professional and institutional investors only.{" "}
        <Link to="/investor-access">Investor access statement</Link>
      </div>
    </div>
  );
}
